import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SaveButtonWithModal from "./SaveButtonWithModel";
import { uploadToCloudinary } from "../utils/CloudinaryUpload";
const OrganizationForm1 = ({
  formData,
  onFormDataChange,
  selectedOption,
  onCertificatesUrlChange, // ADD THIS
  onIdUrlChange,
  onOptionChange,
  onSave,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCircles, setSelectedCircles] = useState({});
  const [images, setImages] = useState([null, null, null, null]);
  const [showModal, setShowModal] = useState(false);
  const [certFiles, setCertFiles] = useState([null, null, null, null]);
  const [idFile, setIdFile] = useState(null);
  const [idImageUrl, setIdImageUrl] = useState(null);
  const [saving, setSaving] = useState(false); // for upload
   const [documentDropdownOpen, setDocumentDropdownOpen] = useState(false);
    const [selectedDocumentType, setSelectedDocumentType] = useState("All Documents");
  
  const toggleCircle = (item) => {
    setSelectedCircles((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };


  const handleOptionClick = (option) => {
    onOptionChange(option);
    setIsOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    onFormDataChange({ ...formData, [name]: value });
  };

  const handleDeleteImage = (index) => {
    setImages((prevImages) => {
      if (!prevImages[index]) return prevImages;
      const newImages = [...prevImages];
      newImages[index] = null;
      return newImages;
    });
    setCertFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles[index] = null;
      return newFiles;
    });
  };
  const documentTypes = [
    "All Documents",
    "National identity card",
    "Business registration",
    "Trade Certificate",
    "Tax compliance"
  ];
  const documentTitles = [
    "National identity card",
    "Business registration",
    "Trade Certificate",
    "Tax compliance",
  ];

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImages((prevImages) => {
        const newImages = [...prevImages];
        newImages[index] = imageUrl;
        return newImages;
      });
      setCertFiles((prevFiles) => {
        const newFiles = [...prevFiles];
        newFiles[index] = file;
        return newFiles;
      });
    }
  };

  const handleIdChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIdFile(file);
      setIdImageUrl(URL.createObjectURL(file));
    }
  };

  // Save handler: upload images, then call onSave with URLs included!
  const handleSave = async () => {
    setSaving(true);
    let certUrls = [];
    let idUrl = "";

    // Upload certificates files to Cloudinary
    for (let i = 0; i < certFiles.length; i++) {
      if (certFiles[i]) {
        const url = await uploadToCloudinary(certFiles[i]);
        certUrls.push(url);
      }
    }
    if (onCertificatesUrlChange) onCertificatesUrlChange(certUrls); // Pass URLs up
    if (certUrls.length) {
      console.log("Certificates URLs:", certUrls);
    }

    // Upload ID doc to Cloudinary
    if (idFile) {
      idUrl = await uploadToCloudinary(idFile);
      if (onIdUrlChange) onIdUrlChange(idUrl);
      if (idUrl) {
        console.log("ID Document URL:", idUrl);
      }
    }

    setSaving(false);
    setShowModal(true);

    // Call parent's onSave with all org fields and attached cert/id URLs
    onSave({
      ...formData,
      certificates: certUrls,
      idDocument: idUrl,
      typeOfOrganization: selectedOption,
    });
  };
  const RequiredAsterisk = () => <span className="text-red-500">*</span>;
  return (
    <div className="md:px-0 md:mt-14">
      {/* ...existing UI... */}
      <div className="relative flex items-center justify-center ">
        <h2 className="text-center font-bold text-[10px] tracking-wide md:text-[36px] md:-mb-2 text-black">
         ORGANISATION INFORMATION
        </h2>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745959571/Expand_down_bh84c9.png"
          alt="Expand"
          className="absolute right-0 w-3 h-3 md:w-11 md:h-11"
        />
      </div>

      <p className="text-center text-[8px] md:text-[32px] text-black md:mb-8 mb-4">
        Co-Operative and Company Applications Only
      </p>

      <div className="grid grid-cols-2 md:grid-cols-2 md:gap-6 gap-2">

        {/* Cooperative Name */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold mb-1 md:pl-4">
            <RequiredAsterisk /> Cooperative Name
          </label>
          <input
            type="text"
            name="cooperativeName"
            value={formData.cooperativeName || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] md:px-10 px-2 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXX"
          />
        </div>

        {/* Type of organization */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold mb-1 md:pl-4">
            <RequiredAsterisk /> Type of organization
          </label>
          <div className="relative w-full">
            <div
              className="bg-[#2E453D] w-full h-[20px] md:h-[71px] md:pl-4 pl-2 rounded-[5px] flex items-center justify-between cursor-pointer border-[#152C24] text-white text-[8px] md:text-[32px] font-medium"
              onClick={() => setIsOpen(!isOpen)}
            >
              {selectedOption}
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745912768/Expand_down_13_cczugb.png"
                alt="Expand Icon"
                className="w-4 h-4 hidden md:flex md:h-[71px] md:w-[80px] bg-[#152C24] md:px-6 md:py-5"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745694878/Expand_down_11_jcywal.png"
                alt="Expand Icon"
                className="w-4 h-4 md:hidden flex"
              />
            </div>
            <AnimatePresence>
              {isOpen && (
                <motion.ul
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  className="absolute z-10 mt-1 w-full bg-[white] rounded-[5px] border-[1px]  border-[#979797]/80 shadow-lg p-2"
                >
                  <li className="flex items-center justify-between px-4 py-1 mb-2">
                    <span className="text-black text-[8px] md:text-[30px] font-semibold">
                      TYPE OF ORGANIZATION
                    </span>
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                      alt="icon"
                      className="md:w-[30px] md:h-[30px] h-[10px] w-[10px]"
                    />
                  </li>
                  {["Individual", "Entrepreneur", "Community", "Cooperative"].map((item, index) => (
                    <li
                      key={index}
                      className="flex items-center justify-between px-4 py-2 rounded-md cursor-pointer"
                      onClick={() => handleOptionClick(item)}
                    >
                      <span className="text-black text-[10px] md:text-[24px] font-medium">
                        {item}
                      </span>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleCircle(item);
                        }}
                        className={`w-4 h-4 md:w-8 md:h-8 rounded-full ${selectedCircles[item] ? "bg-[#03897B]" : "bg-gray-200"}`}
                      ></div>
                    </li>
                  ))}
                </motion.ul>
              )}
            </AnimatePresence>
          </div>
        </div>

        {/* Registration number */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> Registration number
          </label>
          <input
            type="text"
            name="registrationNumber"
            value={formData.registrationNumber || ''}
    onChange={(e) => 
      onFormDataChange({
        ...formData,
        registrationNumber: e.target.value
      })
    }
          
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXXXXXXX"
          />
        </div>

        {/* Members */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> Members of the Organization
          </label>
          <input
            type="text"
            name="members"
            value={formData.members || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXXXXX"
          />
        </div>

        {/* Mobile */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold mb-1 md:pl-4">
            <RequiredAsterisk /> WhatsApp / Mobile phone number
          </label>
          <div className="flex flex-row items-center">
            <div className="flex-1 md:mt-0 -mt-1.5">
              <input
                type="tel"
                name="mobileNumber"
                value={formData.mobileNumber || ""}
                onChange={handleChange}
                placeholder="XXXXXXXX"
                className="w-full h-[20px] md:h-[71px] p-1 md:px-10 border-[#E7EBEB] rounded-[5px] text-[8px] md:text-[32px] text-black font-medium placeholder:text-black bg-[#E7EBEB]"
              />
            </div>
          </div>
        </div>

        {/* Address */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> Physical Address
          </label>
          <input
            type="text"
            name="physicalAddress"
            value={formData.physicalAddress || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXXXXXX"
          />
        </div>

        {/* Chair Name */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> Chair Person First Name
          </label>
          <input
            type="text"
            name="chairFirstName"
            value={formData.chairFirstName || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXX"
          />
        </div>

        {/* Chair Surname */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> Surname
          </label>
          <input
            type="text"
            name="chairSurname"
            value={formData.chairSurname || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXX"
          />
        </div>

        {/* Secretary Name */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> General Secretary First Name
          </label>
          <input
            type="text"
            name="secretaryFirstName"
            value={formData.secretaryFirstName || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXXXX"
          />
        </div>

        {/* Secretary Surname */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> Surname
          </label>
          <input
            type="text"
            name="secretarySurname"
            value={formData.secretarySurname || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXXX"
          />
        </div>

        {/* Email */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> Email address
          </label>
          <input
            type="text"
            name="email"
            value={formData.email || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXXXXXX"
          />
        </div>

        {/* Password */}
        <div>
        <label className="block text-[8px] md:text-[32px] font-bold -mb-1 md:pl-4">
            <RequiredAsterisk /> Password
          </label>
          <input
            type="text"
            name="password"
            value={formData.password || ""}
            onChange={handleChange}
            className="bg-[#E7EBEB] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#E7EBEB] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium"
            placeholder="XXXXXX"
          />
        </div>
      </div>
      <SaveButtonWithModal/>


      {/* Save Button */}

      {/* Save Modal */}
      {showModal && (
        <SaveButtonWithModal
          isOpen={showModal}
          onRequestClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default OrganizationForm1;